@if(loader){
<app-loader></app-loader>
}

<p-card>

    <p-dataView #dv [value]="listQuotes" layout="list">

        <ng-template let-listquote pTemplate="list">

            <div class="flex justify-content-between align-items-center flex-wrap w-100 position-relative">
                <div class="flex align-items-center">
            
                <div>
                    <p-button label="New" (onClick)="create()" class="p-button-outlined" icon="pi pi-plus-circle" size="small"
                        pTooltip="Create Quote"></p-button>
                </div>
            
                <div class="flex align-items-center ml-3">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" [(ngModel)]="searchKey" [placeholder]="placeholder" class=" p-inputtext-sm"
                            (keyup.enter)="searchQuote()" 
                            style="height: 35px; font-size: 0.875rem; padding-left: 2rem;" autocomplete="one-time-code"/>
                    </span>
                    <p-button icon="pi pi-search" (onClick)="searchQuote()"
                            [style]="{'margin': '5px 5px 5px 5px', 'height': '35px', 'line-height': '50px'}" [raised]="true"
                            [size]="'small'" severity="info"></p-button>
                </div>
                 <p-button (onClick)="editQuote()" *ngIf="selectedQuote && selectedQuote.length == 1" label="Edit"
                        class="p-button-outlined ml-2 " icon="pi pi-user-edit" severity="secondary" size="small"></p-button>
                 <p-button (onClick)="deleteQuote()" *ngIf="selectedQuote && selectedQuote.length > 0" label="Delete"
                        class="p-button-outlined ml-2" icon="pi pi-trash" severity="danger" size="small"></p-button>
                   
                </div>

                <h2 class="page-title-center">Quote List</h2>            
                <div class="flex">
                    <div class="flex align-items-center">
                        <p-button (onClick)="sendOrderEmail()" label="Send Mail" class="p-button-outlined ml-2" icon="pi pi-envelope"
                        severity="info" size="small"></p-button>
                        <p-button icon="pi pi-refresh" size="small" (onClick)="refreshData()" [rounded]="true"
                            severity="info" class="ml-2"></p-button>
                    </div>&nbsp;
                </div>
            </div>

            <p-table #dt1 [value]="listQuotes" [scrollable]="true" scrollHeight="613px" styleClass="p-datatable-striped"
                responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm " [paginator]="true" [rows]="10"
                [(selection)]="selectedQuote" [globalFilterFields]="['salesOrderNumber','customer.customerName']"
                [rowsPerPageOptions]="[10 ,15, 20]" (onPage)="loadQuoteList($event)" [rowHover]="true" [selectionPageOnly]="true">

                <ng-template pTemplate="header">
                    <tr>
                        <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
                        <th>Quote No</th>
                        <th>Order Date</th>
                        <th>Bill TO Customer</th>
                        <!-- <th>Bill To Code </th> -->
                        <th>Ship To Customer</th>
                        <th style="text-align: right;">Order Total </th>
                        <th style="text-align: center;">Created By </th>
                        <th>Print </th>

                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-quote>
                    <tr>
                        <td> <p-tableCheckbox [value]="quote"></p-tableCheckbox> </td>
                        <td class="text-blue-500 underline" style="cursor: pointer;" (click)="editQuote(quote)">
                            {{quote.salesOrderNumber}}</td>
                        <td>{{quote.orderDate | date: 'dd/MM/yyyy'}}</td>
                        <td>{{quote.customer.customerName}}</td>
                        <!-- <td>{{quote.billToCustomerCode}}</td> -->
                        <td>{{quote.shipToCustomerCode}}</td>
                        <td class="text-right"><span>₹ {{ quote.orderTotal.toLocaleString('en-IN',{ minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span></td>
                        <td style="text-align: center;">{{quote.createdBy}}</td>
                        <td><span class="pi pi-print" style="color: rgb(0 35 255); cursor: pointer;" (click)="showReport(quote)"></span></td>
                    </tr>
                </ng-template>

            </p-table>

        </ng-template>

    </p-dataView>

</p-card>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

